export default {
      id: "replay-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#replay-usage",
      toString: function () {
        return this.url;
      }
    }